module.exports = __webpack_public_path__ + "static/media/More-Options-Highlighted.4f6da50e.svg";